import * as tslib_1 from "tslib";
import { CouponActionTypes } from '../types/ActionTypes';
var initialState = {
    type: CouponActionTypes.INITIAL_STATE,
    couponCode: null,
    couponReference: null,
    validUntil: null
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CouponActionTypes.RECEIVE_COUPON: {
            return {
                type: CouponActionTypes.RECEIVE_COUPON,
                couponCode: action.couponCode,
                couponReference: action.couponReference,
                validUntil: action.validUntil
            };
        }
        case CouponActionTypes.RECEIVE_COUPON_FAILED: {
            return tslib_1.__assign({}, state, { type: CouponActionTypes.RECEIVE_COUPON_FAILED });
        }
        default: {
            return tslib_1.__assign({}, state, { type: action.type });
        }
    }
};
export { reducer as couponReducer };
